
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Building2, LayoutGrid, ShieldCheck, LogOut, Sofa, FolderOpen } from 'lucide-react';

interface SidebarProps {
    isOpen?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({ isOpen = false }) => {
    const { profile, signOut } = useAuth();
    const location = useLocation();

    return (
        <aside className={`fixed md:relative h-full ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'} w-16 lg:w-14 bg-stone-900 border-r border-stone-800 flex flex-col items-center py-4 z-50 transition-transform duration-300`}>
            {/* Logo / Brand */}
            <div className="mb-8">
                {/* Small Logo Icon */}
                <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center font-bold text-white">D</div>
            </div>

            {/* Nav Items */}
            <nav className="flex-1 w-full flex flex-col gap-4 px-2">
                <abbr title="Architecture">
                    <Link to="/app/architecture" className={`p-3 rounded-xl flex justify-center transition-colors ${location.pathname.startsWith('/app/architecture') ? 'bg-indigo-600 text-white' : 'text-stone-400 hover:bg-stone-800 hover:text-stone-200'}`}>
                        <Building2 size={24} strokeWidth={1.5} />
                    </Link>
                </abbr>

                <abbr title="Interior Design">
                    <Link to="/app/interior" className={`p-3 rounded-xl flex justify-center transition-colors ${location.pathname.startsWith('/app/interior') ? 'bg-indigo-600 text-white' : 'text-stone-400 hover:bg-stone-800 hover:text-stone-200'}`}>
                        <Sofa size={24} strokeWidth={1.5} />
                    </Link>
                </abbr>

                <abbr title="Axes Explorer">
                    <Link to="/app/axes" className={`p-3 rounded-xl flex justify-center transition-colors ${location.pathname.startsWith('/app/axes') ? 'bg-indigo-600 text-white' : 'text-stone-400 hover:bg-stone-800 hover:text-stone-200'}`}>
                        <LayoutGrid size={24} strokeWidth={1.5} />
                    </Link>
                </abbr>

                <abbr title="My Plans">
                    <Link to="/app/my-plans" className={`p-3 rounded-xl flex justify-center transition-colors ${location.pathname.startsWith('/app/my-plans') ? 'bg-indigo-600 text-white' : 'text-stone-400 hover:bg-stone-800 hover:text-stone-200'}`}>
                        <FolderOpen size={24} strokeWidth={1.5} />
                    </Link>
                </abbr>

                {profile?.role === 'superadmin' && (
                    <abbr title="Super Admin">
                        <Link to="/admin" className="p-3 rounded-xl flex justify-center text-amber-500 hover:bg-amber-900/20 transition-colors">
                            <ShieldCheck size={24} strokeWidth={1.5} />
                        </Link>
                    </abbr>
                )}
            </nav>

            {/* Footer Actions */}
            <div className="mt-auto flex flex-col gap-4 px-2">
                <button onClick={signOut} className="p-3 rounded-xl flex justify-center text-red-400 hover:bg-red-900/20 transition-colors" title="Sign Out">
                    <LogOut size={20} strokeWidth={1.5} />
                </button>
            </div>
        </aside>
    );
};
